import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullSharePbpOption'));
let SharePbpOption: LazyOption = createLazyOption(
    {
        key: 'sharePbpOption',
        titleStringKey: 'optionTitle_pbpSharingOptions',
        searchTermsStringKey: 'optionTitle_pbp',
        isHidden: () => {
            return !isFeatureEnabled('cal-pbp-option');
        },
    },
    lazyFullModule,
    m => m.default
);
export default SharePbpOption;
